export default __webpack_public_path__ + "static/media/2W.10056622.svg";